<template>
  <div
    class="product-delivery-item"
    :class="{ 'product-delivery-item_disabled': disabled }"
  >
    <div class="product-delivery-item__content">
      <div class="product-delivery-item__title">
        {{ title }}
      </div>

      <div class="product-delivery-item__description">
        <template v-if="disabled">
          Недоступно
        </template>
        <slot v-else>
          <span v-if="description" v-html="description" />
        </slot>
      </div>
    </div>

    <div v-if="icon" class="product-delivery-item__icon">
      <f-sprite-icon :icon-link="icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-delivery-item',

  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style lang="scss">
.product-delivery-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: $gray;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid $gray_lu;
  }

  &__title {
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: $black;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-left: 4px;
    border-radius: 50%;
    background: $gray_bgr;

    .sprite-icon {
      height: 20px;
      width: 20px;
      color: $blue;
    }
  }

  &_disabled {
    color: $gray_l2;
    pointer-events: none;

    .product-delivery-item {
      &__title {
        color: $gray_l2;
      }

      &__icon .sprite-icon {
        color: $gray_l2;
      }
    }
  }
}

@include breakpoint("desktop") {
  .product-delivery-item {
    padding: 16px;
    font-size: 14px;
    line-height: 20px;

    &__title {
      margin-bottom: 4px;
      font-size: 16px;
    }

    &__icon {
      height: 48px;
      width: 48px;

      .sprite-icon {
        height: 24px;
        width: 24px;
      }
    }
  }
}
</style>
